module.exports = __webpack_public_path__ + "img/medixtra.1dc1b2fe.jpg";